import React from 'react';

export default function LocationPinIcon({ className = '' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" role="img" aria-hidden="true" focusable="false">
      <path d="M12 21s7-6.2 7-12A7 7 0 0 0 5 9c0 5.8 7 12 7 12Z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      <circle cx="12" cy="9" r="2.25" fill="none" stroke="currentColor" strokeWidth="1.8" />
    </svg>
  );
}
